import type { BookingDTO } from '@/types/dto/agent';
import { useMemo } from 'react';

export const useBookingTrips = (booking: BookingDTO | null) =>
  useMemo(() => {
    const allTrips = booking?.bookedTrips || [];
    const outboundTrips = allTrips.filter((trip) => trip.isOutbound);
    const inboundTrips = allTrips.filter((trip) => !trip.isOutbound);

    return { outboundTrips, inboundTrips };
  }, [booking]);
